import { v4 } from 'uuid';
import JSON5 from 'json5';

export default class BaseComponent extends HTMLElement {
  static ComponentLoadTime = 500;
  componentErrors = [];
  constructor() {
    super();
    this.componentId = `${this.constructor.name}_${v4()}`;
    this.phoneSizeThreshold = 1000;
    this.isSmall = window.innerWidth < this.phoneSizeThreshold;
    this.state = {};
    this.data = {};

    this.updateData();
    this.attachShadow({ mode: 'open' });
    this.onConstruct();
    this.updateShadowRoot();
  }

  isMobileDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /mobile|android|iphone|ipad|ipod|blackberry|windows phone/.test(
      userAgent
    );
  }

  updateData() {
    const dataElements = this.querySelectorAll('data');

    if (!dataElements || dataElements.length < 1) {
      return;
    }

    for (const datum of dataElements) {
      const name = datum.getAttribute('name');
      const type = datum.getAttribute('type');

      let content = `${datum.textContent}`.trim();

      if (type === 'string') content = content;

      if (type === 'json') {
        try {
          content = JSON5.parse(content);
        } catch (e) {
          console.error('catched');
          content = {};
        }
      }
      console.log('======== aqui');
      this.data[name] = { name, type, value: content };
    }
  }

  updateShadowRoot() {
    this.shadowRoot.innerHTML = this.render();
  }
  render() {
    return `<div></div>`;
  }
  onResize() {}

  onConnect() {}

  afterMount() {}

  onConstruct() {}

  addError(e) {
    if (this.componentErrors.includes(e)) return;
    this.componentErrors.push(e);
    const solved = this.onError(e);
    if (solved) this.solveError(e);
  }

  solveError(e) {
    const indexToDelete = this.componentErrors.findIndex(e);
    if (indexToDelete >= 0 && indexToDelete < this.componentErrors.length) {
      this.componentErrors.splice(indexToDelete, 1);
    }
  }

  onError(e) {
    return false;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    let parsedValue;

    try {
      parsedValue = JSON.parse(newValue);
    } catch (e) {
      parsedValue = newValue;
    }

    this.state = { ...this.state, [name]: parsedValue };
    this.updateShadowRoot();
    this.afterMount();
  }

  connectedCallback() {
    if (!this.isMobileDevice()) {
      window.addEventListener('resize', () => {
        this.isSmall = window.innerWidth < this.phoneSizeThreshold;
        this.updateShadowRoot();
        this.onResize();
        this.afterMount();
      });
    }

    this.updateShadowRoot();
    this.onConnect();

    setTimeout(() => this.afterMount(), BaseComponent.ComponentLoadTime);
  }
}

function style(styleString) {
  return `
  <style>
  ${styleString}
  </style>
  `;
}

function htmlMap(array, callback) {
  return array.map((a) => callback(a)).join('');
}

class HtmlArray extends Array {
  map(callbackfn, thisArg) {
    super.map(callbackfn, thisArg).join('');
  }
}

function defineComponent(name, constructor) {
  if (!customElements.get(name)) {
    customElements.define(name, constructor);
  }
}

function defineComponentFromClass(constructor) {
  function classNameToKebab(className) {
    return className
      .replace(/([a-z])([A-Z])/g, '$1-$2') // Insert hyphen between lower & upper
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .toLowerCase(); // Convert to lowercase
  }
  defineComponent(classNameToKebab(constructor.name), constructor);
}

export { style, defineComponent, defineComponentFromClass };
